export default __webpack_public_path__ + "static/media/nptel_logo.179ef619.png";